import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useUrlGenerator } from '@folklore/react-container';
import { defineMessages } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';
import Button from '../buttons/Button';

import styles from '../../../styles/partials/credits.scss';

const messages = defineMessages({
    button: {
        id: 'content.credits_button',
        defaultMessage: 'Full Website Credits',
    },
});

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            position: PropTypes.string,
            names: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
};

const defaultProps = {
    className: null,
    items: [
        {
            position: 'Writer and Director',
            names: ['Tamara Mariam Dawit'],
        },
        {
            position: 'Featuring',
            names: [
                'Tsehai Tesfamichael',
                'Abrehet Asefa',
                'Tamara Mariam Dawit',
                'Kibre Dawit',
                'Tsion Dawit',
                'Brutawit Dawit',
                'Menbere Dawit',
                'Ferkete Gebremariam',
                'Ashenafi Kersma',
                'Brur Gebrai',
            ],
        },
        {
            position: 'Producer',
            names: ['Isabelle Couture'],
        },
        {
            position: 'Director of Photography',
            names: ['Alex Margineanu'],
        },
        {
            position: 'Editor',
            names: ['Mahi Rahgozar'],
        },
        {
            position: 'Original Music',
            names: ['Zaki Ibrahim'],
        },
        {
            position: 'Sound',
            names: ['Catherine Van Der Donckt'],
        },
        {
            position: 'Executive Producer',
            names: ['Katarina Soukup'],
        },
        {
            position: 'Distribution \xa0|\xa0 Canada',
            names: ['Cinema Politica'],
        },
        {
            position: 'World Sales',
            names: ['Rise & Shine'],
        },
        {
            position: 'Website Producers',
            names: ['Kathy Sperberg', 'Isabelle Couture'],
        },
        {
            position: 'Digital Marketing & Community Outreach',
            names: ['Kathy Sperberg'],
        },
        {
            position: 'Social Media & Online Engagement',
            names: ['Jackie Garrow \xa0|\xa0 Ring Five Impact Docs'],
        },
        {
            position: 'Website Art Direction',
            names: ['Dominic Turmel', 'Raymond Deblois'],
        },
        {
            position: 'Finding Sally Title Design',
            names: ['Kevin Lo \xa0|\xa0 LOKI DESIGN'],
        },
        {
            position: 'trailer video editor',
            names: ['Tamara Scherbak'],
        },
        {
            position: 'Web Developer',
            names: [
                'David Mongeau-Petitpas \xa0|\xa0 Folklore',
                'Brandon Tam \xa0|\xa0 Folklore',
                'Jessica Johnson \xa0|\xa0 Folklore',
            ],
        },
        {
            position: 'Publicity',
            names: ['Ingrid Hamilton \xa0|\xa0 GAT PR', 'Macy Armstrong \xa0|\xa0 GAT PR'],
        },
    ],
};

const Credits = ({ items, className }) => {
    const urlGenerator = useUrlGenerator();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <h4 className={styles.title}>Credits</h4>
                <div className={styles.credits}>
                    <dl>
                        {items.map(({ position, names }) => (
                            <Fragment key={`credit-${position}`}>
                                <dt className={styles.position}>{position}</dt>
                                <dd className={styles.names}>
                                    <ul>
                                        {names.map(name => (
                                            <li key={`credit-${position}-${name}`}>{name}</li>
                                        ))}
                                    </ul>
                                </dd>
                            </Fragment>
                        ))}
                    </dl>
                </div>
                <Button
                    type="button"
                    label={messages.button}
                    className={styles.button}
                    href={urlGenerator.route('credits')}
                />
            </div>
        </div>
    );
};

Credits.propTypes = propTypes;
Credits.defaultProps = defaultProps;

export default Credits;
